import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface MobileScreenPreviewProps {
  title: string;
  image: string;
  alt: string;
}

export default function MobileScreenPreview({
  title,
  image,
  alt,
}: MobileScreenPreviewProps) {
  return (
    <Box
      sx={{
        mx: 'auto',
        width: '100%',
        maxWidth: 360,
        p: 1.25,
        borderRadius: '32px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'rgba(9, 17, 29, 0.78)',
        boxShadow: '0 24px 50px rgba(0, 0, 0, 0.28)',
      }}
    >
      <Stack spacing={1.25}>
        <Box
          sx={{
            px: 2,
            py: 1.25,
            borderRadius: '22px',
            border: '1px solid rgba(126, 165, 214, 0.14)',
            bgcolor: 'rgba(255,255,255,0.04)',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'primary.light',
              letterSpacing: 1.8,
              textTransform: 'uppercase',
            }}
          >
            Mobile app
          </Typography>
          <Typography variant="h6" sx={{ mt: 0.25 }}>
            {title}
          </Typography>
        </Box>
        <Box
          component="img"
          src={image}
          alt={alt}
          sx={{
            width: '100%',
            display: 'block',
            borderRadius: '24px',
            border: '1px solid rgba(126, 165, 214, 0.14)',
            backgroundColor: '#0f1626',
          }}
        />
      </Stack>
    </Box>
  );
}
